"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedProductProjectWithoutInDetailResponse = exports.mockedProductProjectResponse = void 0;
const omit_util_1 = require("../../utils/omit.util");
const price_1 = require("../price");
const product_in_detail_1 = require("../product-in-detail");
exports.mockedProductProjectResponse = {
  id: 1,
  name: {
    id: 1,
    ru: 'имя',
    en: 'name'
  },
  saleStartAt: new Date(),
  saleEndAt: null,
  startAt: new Date(),
  endAt: new Date(),
  isActive: false,
  prices: [price_1.mockedPriceResponse],
  productInDetail: product_in_detail_1.mockedProductInDetailResponse,
  clubId: null,
  photos: []
};
exports.mockedProductProjectWithoutInDetailResponse = omit_util_1.omitObject(exports.mockedProductProjectResponse, 'productInDetail');